export const BILLING_FREQUENCY = {
  MONTHLY: 1,
  QUARTERLY: 3,
  SEMI_ANNUALLY: 6,
  ANNUALLY: 12,
} as const;

export const SUBSCRIPTION_STATUS = {
  ONBOARDING: "onboarding",
  CANCELLED: "cancelled",
  PAYMENT_FAILED: "payment_failed",
  INCOMPLETE: "incomplete",
  ACTIVE: "active",
  PAID_IN_HEALTHIE: "paid_in_healthie",
} as const;

export const INACTIVE_STATUSES = [
  SUBSCRIPTION_STATUS.ONBOARDING,
  SUBSCRIPTION_STATUS.CANCELLED,
  SUBSCRIPTION_STATUS.PAYMENT_FAILED,
  SUBSCRIPTION_STATUS.INCOMPLETE,
] as const;

export const SUBSCRIPTION_VENDOR = {
  OPEN_LOOP: "openloop",
  WHITE_COAT: "whitecoat",
} as const;

export const INTAKE_STATUS = {
  REQUIRE_SCHEDULE: "require_schedule_initial_appointment",
} as const;
